import { createAsyncThunk } from "@reduxjs/toolkit";
import companyDetailsService from "../../services/companyDetailsService";

export const getCompanyDetailsThunk = createAsyncThunk(
  "companyDetails/getCompanyDetails",
  async (customerId, { rejectWithValue }) => {
    try {
      const response = await companyDetailsService.getCompanyDetails(customerId);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Ensure you're not modifying companyDetailsData before passing it to the service
export const addCompanyDetailsThunk = createAsyncThunk(
  "companyDetails/addCompanyDetails",
  async (companyDetailsData, { rejectWithValue }) => {
    try {
      const response = await companyDetailsService.addCompanyDetails(companyDetailsData);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Ensure you're not modifying companyDetailsData before passing it to the service
export const updateCompanyDetailsThunk = createAsyncThunk(
  "companyDetails/updateCompanyDetails",
  async (companyDetailsData, { rejectWithValue }) => {
    try {
      const response = await companyDetailsService.updateCompanyDetails(companyDetailsData);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);
